<template>
   <a-select :disabled="disabled" :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners"  :placeholder="placeholder?placeholder:$t('baseVO.selectPlaceholder')">
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,index) in companyInfos" :disabled="disabledIds.length > 0 && disabledIds.indexOf(item.id) > -1" :key="index" :value="item.id">{{item.name}}</a-select-option>
   </a-select>
</template>

<script>
  import UserApi from '@/api/sys/user'
  import { mapState } from 'vuex'
  import store from '@/store'
  export default {
    name: 'ptFilterCompanySelect',
    props:{
      disabled:{
        type:Boolean,
        default:false,
      },
      placeholder:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledIds:{
        type:Array,
        default:()=>{return []},
      },
      //是否设置默认值第一个
      isFirst:{
        type:Boolean,
        default: false,
      },
      selectNow:{
        type:Boolean,
        default: false,
      }
    },
    computed:{
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    data() {
      return {
        input:this.value,
        companyInfos:[],
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
      input(val){
        this.$emit('input',val)
      }
    },
    mounted(){
      console.log("重新渲染了=====")
      this.initData()
    },
    methods:{
      initData(){
       let permissions = this.$store.getters.roles.permissions
        if(permissions instanceof Array){
          if(permissions.indexOf("EMPLOYEECONTROLLER_GETCOMPANYINFO") != -1){
            UserApi.getCompanyInfo().then(res=>{
              if(res.code == 1){
                this.companyInfos = res.data
                if(this.isFirst && !this.value){
                  this.input = this.userInfo.employeeDO.companyId
                  this.$emit('input',this.input)
                  this.$emit('change',this.input);
                }
              }
            })
          }else {
            if(this.selectNow){
              UserApi.getLoginCompanyInfo().then(res=>{
                if(res.code == 1){
                  this.companyInfos = res.data
                  if(this.isFirst && !this.value){
                    this.input = this.userInfo.employeeDO.companyId
                    this.$emit('input',this.input)
                    this.$emit('change',this.input);
                  }
                }
              })
            }
          }
        }

      },
      changeValue(value){
        this.$emit('input',value)
      }
    }
  }
</script>

<style scoped lang="less">

</style>